import React from "react";
import { Close } from "@mui/icons-material";
import { Dialog, DialogContent, DialogActions, DialogTitle, IconButton, Button } from "@mui/material";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../common/constants/commonConstants.js";

const DialogComponent = ({
    open,
    setWidth = "sm",
    onClose,
    title,
    children,
    actions,
}) => {
    return (
        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth={setWidth}>
                <DialogTitle>
                    {title}
                </DialogTitle>
                <IconButton sx={{ position: "absolute", top: 10, right: 10 }} onClick={onClose}>
                    <Close />
                </IconButton>
                <DialogContent dividers>
                    {children}
                </DialogContent>
                <DialogActions sx={{ gap: 1, pr: 2, backgroundColor: "#FAFAFA" }}>
                    <Button variant={VARIANTS.OUTLINED} color={BUTTON_COLORS.INFO} onClick={onClose}>
                        {STRINGS.CANCEL}
                    </Button>
                    {actions}
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DialogComponent;